// @ts-nocheck

import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import ControlOutlined from '@ant-design/icons/ControlOutlined';
import BulbOutlined from '@ant-design/icons/BulbOutlined'

export default {
  DashboardOutlined,
DatabaseOutlined,
ControlOutlined,
BulbOutlined
}
    